export const contractHeaderOptions = [
  // { label: 'Update', value: 'Update', callback: 'onClickupdate' }
  { label: 'Print', value: 'print', callback: 'onClickPrint' },
  { label: 'History', value: 'History', callback: 'onViewHistory' },
  // { label: 'Transaction', value: 'Transaction', callback: 'onClickTransaction' }
  { label: 'Cancel Contract', value: 'Cancel', callback: 'onClickCancelContract' }
];
